// card header fonts options

const fonts = [
  {
    id: -1,
    name: 'None (Helvetica)',
    previewImage: null
  },
  {
    id: 1,
    name: 'apris',
    previewImage: 'https://files.kinopio.club/font-preview/apris.webp'
  },
  {
    id: 8,
    name: 'eiko',
    previewImage: 'https://files.kinopio.club/font-preview/eiko.webp'
  },
  {
    id: 9,
    name: 'baustrabe',
    previewImage: 'https://files.kinopio.club/font-preview/Baustraße.webp'
  },
  {
    id: 2,
    name: 'gaya',
    previewImage: 'https://files.kinopio.club/font-preview/gaya.webp'
  },
  {
    id: 6,
    name: 'grotesk-remix',
    previewImage: 'https://files.kinopio.club/font-preview/grotesk-remix.webp'
  },
  {
    id: 3,
    name: 'gt-america',
    previewImage: 'https://files.kinopio.club/font-preview/gt-america.webp'
  },
  {
    id: 5,
    name: 'microgramma',
    previewImage: 'https://files.kinopio.club/font-preview/microgramma.webp',
    size: 's'
  },
  {
    id: 7,
    name: 'migra',
    previewImage: 'https://files.kinopio.club/font-preview/migra.webp'
  },
  {
    id: 0,
    name: 'recoleta',
    previewImage: 'https://files.kinopio.club/font-preview/recoleta.webp'
  },
  {
    id: 4,
    name: 'shinka-mono',
    size: 's',
    previewImage: 'https://files.kinopio.club/font-preview/shinka-mono.webp'
  }
]

export default fonts
